import { useTranslation } from 'react-i18next'
import { Form, Input, App } from 'antd';
import { useImperativeHandle, forwardRef } from 'react';
import { useSearchParams } from 'react-router-dom'
import { importOmop } from '@/api/dictionary'
import CustomUpload from './customUpload';

const MeddraForm = (props, ref: any)=> {
    const { message } = App.useApp();
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const [searchParams] = useSearchParams()
    const dictName = searchParams.get('dictName') || ''

    const onFinish = async ()=>{
        try {
            const values = await form.validateFields()
            const params = new FormData()
            params.append('conceptFile', values.conceptFile.file);
            params.append('conceptClassFile', values.conceptClassFile.file);
            params.append('domainFile', values.domainFile.file);
            params.append('conceptRelationShipFile', values.conceptRelationShipFile.file);
            await importOmop(dictName, values.version, params);
            message.success(t('ikg.success', { action: t('dict.addVersion') }))
          } catch (error) {
            throw error
          }
    }

    useImperativeHandle(ref, () => {
        return {
          submit: onFinish,
          resetFields: ()=> {form.resetFields()}
        };
      }, []);

    return <Form
        layout="vertical"
        form={form}
        autoComplete="off"
        initialValues={{
            dictName
        }}
    >
        <Form.Item
            label={t('dict.dictName')} // 字典名称
            name="dictName"
        >
            <Input disabled />
        </Form.Item>
        <Form.Item
        label={t('dict.version')} // 字典名称
        name="version"
        rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.version') }),
            },
        ]}
        >
            <Input placeholder={t('ikg.input', { name: t('dict.version') })} />
        </Form.Item>
        <Form.Item
            label={t('dict.conceptcsv')}
            name="conceptFile"
            rules={[
                {
                required: true,
                message: t('ikg.input', { name: t('dict.conceptcsv') }),
                },
            ]}
        >
            <CustomUpload accept=".csv" fileName='CONCEPT.csv' />
        </Form.Item>
        <Form.Item label={t('dict.conceClasscsv')} name="conceptClassFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.conceClasscsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='CONCEPT_CLASS.csv' />
        </Form.Item>
        <Form.Item label={t('dict.domaincsv')} name="domainFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.domaincsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='DOMAIN.csv' />
        </Form.Item>
        <Form.Item label={t('dict.conceRelcsv')} name="conceptRelationShipFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.conceRelcsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='CONCEPT_RELATIONSHIP.csv' />
        </Form.Item>
    </Form>
}

export default forwardRef(MeddraForm)
